<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Simulación</strong>
          </CCardHeader>
          <CCardBody>
            <b-form id="Form" autocomplete="off" @submit.prevent="Validate">
              <b-row class="row justify-content-center">

                <b-col md="2">
                  <b-form-group label="Tipo de Crédito:">
                    <b-form-select @change="ListFinancialData" v-model="credit.id_product" :options="products"></b-form-select>
                    <small v-if="errors.id_product"  class="form-text text-danger" >Seleccione un Tipo</small>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="TEA:">
                    <b-form-select v-model="credit.id_financial_data" :options="financial_data"></b-form-select>
                    <small v-if="errors.id_financial_data"  class="form-text text-danger" >Seleccione un Tipo</small>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Monto:">
                    <b-form-input class="text-right" v-model="credit.amount" type="number" step="any"></b-form-input>
                    <small v-if="errors.amount"  class="form-text text-danger" >Ingrese un monto</small>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Cuotas:">
                    <b-form-input class="text-center" v-model="credit.dues" type="number" step="any"></b-form-input>
                    <small v-if="errors.dues"  class="form-text text-danger" >Ingrese una cuota</small>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Fecha de Desembolso:">
                    <b-form-input class="text-center" v-model="credit.disbursement_date"  type="date" ></b-form-input>
                    <small v-if="errors.disbursement_date"  class="form-text text-danger" >Ingrese una fecha</small>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Fecha de Pago:">
                    <b-form-input class="text-center" v-model="credit.payment_date" :min="credit.now_date" type="date" ></b-form-input>
                    <small v-if="errors.payment_date"  class="form-text text-danger" >Ingrese una fecha</small>
                  </b-form-group>
                </b-col>

                <b-col md="2" v-if="credit.id_product == 2">
                  <b-form-group label=".">
                    <b-button type="button" variant="warning" @click="ShowModalPaymentCapital" class="form-control" >Pago del Capital</b-button>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label=".">
                    <b-button type="submit" class="form-control" ><i class="fas fa-save"></i> Simular</b-button>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label=".">
                    <b-button type="button" @click="CleanLoan" variant="info" class="form-control" >Limpiar Cronograma</b-button>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>

            <div class="table-responsive mt-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="3%" class="text-center">#</th>
                    <th width="17%" class="text-center">Cuota</th>
                    <th width="17%" class="text-center">Fecha</th>
                    <th width="17%" class="text-center">Capital</th>
                    <th width="17%" class="text-center">Interes</th>
                    <th width="17%" class="text-center">Saldo</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in loan_detail" :key="it">
                  <tr>
                    <td class="text-center">{{ item.quota_number }}</td>
                    <td class="text-right"> {{ item.quota  }}</td>
                    <td class="text-center"> {{ item.date  }}</td>
                    <td class="text-right"> {{ item.capital_balance  }}</td>
                    <td class="text-right"> {{ item.interest  }}</td>
                    <td class="text-right"> {{ item.balance  }}</td>
                  </tr>
                </tbody>
              </table>
            </div>



            <b-modal size="md" hide-footer v-model="modal_payment_capital" class="" title="Pago del Capital">
              <b-row class="row justify-content-center">

                <b-col md="4">
                  <b-form-group label="Cuota:">
                    <b-form-input v-model="payment_capital.dues" placeholder="0" type="number"  class="text-center"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="4">
                  <b-form-group label="Monto:">
                    <b-form-input v-model="payment_capital.amount" placeholder="0.00" type="number" step="any" class="text-right"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="4">
                  <b-form-group label=".">
                    <b-button type="button" @click="AddPaymentCapital" variant="primary" class="form-control">Agregar</b-button>
                  </b-form-group>
                </b-col>
                
        
              </b-row>

              <div class="table-responsive mt-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="40%" class="text-center">Cuota</th>
                    <th width="50%" class="text-center">Monto</th>
                    <th width="10%" class="text-center">Acc.</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in credit.payment_capital" :key="it">
                  <tr>
                    <td class="text-center">
                      <b-form-input type="number" class="text-right" step="any" v-model="item.dues" @change="EditPaymentCapital(it)"></b-form-input>
                    </td>
                    <td class="text-right">
                      <b-form-input type="number" class="text-right" step="any" v-model="item.amount" @change="EditPaymentCapital(it)"></b-form-input>
                    </td>
                    <td class="text-center">
                      <b-button type="button" @click="DeletePaymentCapital(it)" size="sm" variant="danger"><i class="fas fa-trash"></i></b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            </b-modal>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import CodeToName from "@/assets/js/CodeToName";
var moment = require("moment");
export default {
  name: "SimulationList",
  components:{
    vSelect,
  },
  data() {
    return {
      module:'Simulation',
      role:1,
      credit: {
        id_product: '',
        id_financial_data: '',
        amount: '',
        dues: '',
        disbursement_date: moment(new Date()).local().format("YYYY-MM-DD"),
        payment_date: moment(new Date()).local().format("YYYY-MM-DD"),
        now_date: moment(new Date()).local().format("YYYY-MM-DD"),
        days_of_grace: 0,
        payment_capital: []
      },
      products: [],
      financial_data: [{value:"", text:"- Seleccione una opción -"}],
      payment_capital:{
        dues: '',
        amount: '',
      },
      
      errors:{
        id_product: false,
        id_financial_data: false,
        amount: false,
        dues: false,
        disbursement_date: false,
        payment_date: false,
        payment_capital: false,
      },

      loan_detail: [],

      modal_payment_capital: false,
     
    };
  },
  mounted() {
    this.ListProducts();
  },
  methods: {

    ListProducts,
    ListFinancialData,
    Validate,
    Simulation,

    ShowModalPaymentCapital,
    AddPaymentCapital,
    EditPaymentCapital,
    DeletePaymentCapital,

    CleanLoan,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    id_establishment: function () {
      let establishment = window.localStorage.getItem("id_establishment");
      establishment = JSON.parse(je.decrypt(establishment));
      return establishment;
    }
  },
};

function CleanLoan() {
  this.loan_detail = [];
}

function ShowModalPaymentCapital() {
  this.modal_payment_capital = true;
}

function AddPaymentCapital() {

  if (this.payment_capital.dues.length == 0) {
    Swal.fire({ icon: 'error', text: 'Ingrese una cuota', timer: 3000,})
    return false;
  }

  if (this.payment_capital.amount.length == 0) {
    Swal.fire({ icon: 'error', text: 'Ingrese un monto', timer: 3000,})
    return false;
  }

  this.payment_capital.amount = parseFloat(this.payment_capital.amount).toFixed(2);

  let payment = {
    dues: this.payment_capital.dues,
    amount: this.payment_capital.amount,
  }

  this.credit.payment_capital.push(payment);

  this.payment_capital.dues = '';
  this.payment_capital.amount = '';

}

function EditPaymentCapital(index) {
  this.credit.payment_capital[index].dues =  this.credit.payment_capital[index].dues.length == 0 ? 0 : this.credit.payment_capital[index].dues;
  this.credit.payment_capital[index].amount =  this.credit.payment_capital[index].amount.length == 0 ? 0 : this.credit.payment_capital[index].amount;

  this.credit.payment_capital[index].dues = parseFloat(this.credit.payment_capital[index].dues);
  this.credit.payment_capital[index].amount = parseFloat(this.credit.payment_capital[index].amount).toFixed(2);
}

function DeletePaymentCapital(index) {
  this.credit.payment_capital.splice(index, 1);
}

function ListProducts() {

  let me = this;
  let url = me.url_base + "product/actives";
  me.products = [{ value: '', text:'- Seleccione una opcion - '}];
  axios({
    method: "GET",
    url: url,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module,role: me.role },
  })
  .then(function (response) {
    if (response.data.status == 200) {
      response.data.result.forEach(element => {
        me.products.push({value: element.id_product, text: element.name });
      });
    }

  });
}

function ListFinancialData() {

  let me = this;
  me.financial_data = [{ value: '', text:'- Seleccione una opcion - '}];
  me.credit.id_financial_data = '';
  me.credit.payment_capital = [];
  if (me.credit.id_product.length == 0) {
    return false;
  }
  let url = me.url_base + "financial-data/actives/"+me.credit.id_product;
  axios({
    method: "GET",
    url: url,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module,role: me.role },
  })
  .then(function (response) {
    if (response.data.status == 200) {
      response.data.result.forEach(element => {
        me.financial_data.push({value: element.id_financial_data, text: element.tea + "%" });
        if (element.default == 1) {
          me.credit.id_financial_data = element.id_financial_data;
        }
      });
    }

  });
}

function Validate() {
  this.errors.id_product = this.credit.id_product.length == 0 ? true : false;
  this.errors.id_financial_data = this.credit.id_financial_data.length == 0 ? true : false;
  this.errors.amount = this.credit.amount.length == 0 ? true : false;
  this.errors.dues = this.credit.dues.length == 0 ? true : false;
  this.errors.disbursement_date = this.credit.disbursement_date.length == 0 ? true : false;
  this.errors.payment_date = this.credit.payment_date.length == 0 ? true : false;
  // this.errors.payment_capital = this.credit.payment_capital.length == 0 ? true : false;

  if (this.errors.id_product) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate_add = false; }
  if (this.errors.id_financial_data) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate_add = false; }
  if (this.errors.amount) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate_add = false; }
  if (this.errors.dues) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate_add = false; }
  if (this.errors.disbursement_date) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate_add = false; }
  if (this.errors.payment_date) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate_add = false; }
  if (this.errors.payment_capital) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate_add = false; }

  this.Simulation();
}

function Simulation() {
  let me = this;
  let url = me.url_base + "credit/simulate";
  let data = me.credit;
  axios({
    method: "POST",
    url: url,
    data: data,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module,role: me.role },
  })
  .then(function (response) {
    if (response.data.status == 200) {
      me.loan_detail = response.data.result;
    }else{
      if (me.credit.id_product == 2) {
        me.modal_payment_capital = true;
      }
      Swal.fire({ icon: 'error', text: response.data.message, timer: 2000,}); 
    }

  });
}

</script>